module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens35-95184af644f41d15a58346c1bd8e5191.jpg";